// Remonte la page en haut. Appele par les boutons qui font CHANGER D'ONGLET : le contenu d'un onglet
// est long, et sans ca l'utilisateur arrive au milieu du nouvel onglet (la position de scroll est
// conservee au changement de route/param). Les clics sur la barre d'onglets, eux, n'en ont pas besoin :
// elle est deja en haut de page.
export const scrollToTop = (): void => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
